import { Box, SkeletonLoader } from "@drone-js/core";
import type { FunctionComponent } from "react";

export const Skeleton: FunctionComponent = () => {
    const badge = <SkeletonLoader label="loading" shape="rectangle" width="100px" height="14px" />;

    return (
        <Box display="flex" alignItems="center" height="64px" data-testid="skeleton-container">
            <Box flexShrink={0} me="16">
                <SkeletonLoader label="loading" shape="rectangle" width="64px" height="64px" />
            </Box>
            <Box>
                <Box display="block" pb="2" qM={{ display: "none" }}>
                    {badge}
                </Box>
                <SkeletonLoader label="loading" shape="rectangle" width="200px" height="19px" me="12" />
                <Box display="flex" alignItems="center" pt="2" qM={{ display: "flex", pt: "8" }}>
                    <Box display="none" qM={{ display: "flex" }}>
                        {badge}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
